/**
 * Site JavaScript
 *
 * Ion bundles this file with esbuild on every build, and again on every save
 * while the dev server is running, then hot-reloads the preview. The output is
 * public/assets/js/main.js, which the base template includes via
 * <script src="/assets/js/main.js" defer>.
 *
 * There is no build command to run. Save the file and the preview updates.
 * If the bundle looks stale, that is a bug worth reporting, not something to
 * work around by running a build by hand: public/ is generated and the next
 * build overwrites whatever you put there.
 */

// DOM ready helper
function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  console.log("Site loaded");
});
